import { render } from "./MediaQuadrantsLayout.vue?vue&type=template&id=1139b9d8&scoped=true&ts=true"
import script from "./MediaQuadrantsLayout.vue?vue&type=script&lang=ts"
export * from "./MediaQuadrantsLayout.vue?vue&type=script&lang=ts"

import "./MediaQuadrantsLayout.vue?vue&type=style&index=0&id=1139b9d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1139b9d8"]])

export default __exports__